<template>
    <section class="h-100">
        <front-table :front_page="page"
                     :front_records="records"
                     :front_search="search"
                     :front_header="header"
                     :model="model"
                     @reload="handleReload"
                     @review="handleReview"
                     :btn_add="false"
                     :btn_edit="false"
                     :btn_delete="false"
                     btn_review
        >

            <div class="pull-right">
                <calendar-picker-filter :value="search.date_range" @change="handleCalendarChange" ></calendar-picker-filter>
            </div>
        </front-table>
        <!--编辑界面-->

        <meeting-view :view_mode="view_mode" :single="single" @start="startMeeting" @mail="mailAttendees"
                      @cancel="view_mode = false">
        </meeting-view>

        <div v-show="show_table" ref="excel_table">
            <el-table border size="small"
                      :data="table.data" show-summary
                      style="width: 100%">
                <el-table-column v-for="header in table.headers" :key="header.prop"
                                 :prop="header.prop"
                                 :label="header.label">
                </el-table-column>
            </el-table>
        </div>

    </section>
</template>

<script>
import MyMeetingMixin from "@/views/mixins/my-course"
import "@/views/scss/my-meeting.scss"
import FrontTable from "@/components/front-table";
import MeetingView from "@/components/meeting-view";
import CalendarPickerFilter from "@/components/calendar-picker-filter";

export default {
    name: 'my-course',
    mixins: [MyMeetingMixin],
    components: {MeetingView, FrontTable,CalendarPickerFilter},
}
</script>

